/** Latest sighting per linked animal, plus every unlinked sighting as its own marker. */
export function latestSightingByAnimal<
  T extends { id: number; animal_id: number | null; sighted_at: string },
>(sightings: T[]) {
  const latest = new Map<number, T>()
  const unlinked: T[] = []
  for (const sighting of sightings) {
    if (sighting.animal_id == null) {
      unlinked.push(sighting)
      continue
    }
    const current = latest.get(sighting.animal_id)
    if (
      !current ||
      Date.parse(sighting.sighted_at) > Date.parse(current.sighted_at)
    ) {
      latest.set(sighting.animal_id, sighting)
    }
  }
  return [...latest.values(), ...unlinked]
}
